import environment from '../environment';
import { errorMessage, warning } from './errors';

interface Options {
	url: string;
	credentials?: Credentials;
	excludeApiKey?: boolean;
}

interface Credentials {
	username: string;
	password: string;
}

// @TODO apiKey must be an argument
export async function fetchJSON<P>(
	options: Options,
	// type of `init.headers` is assumed to be string[][]
	init: RequestInit = {}
): Promise<P | undefined> {
	const { credentials, url, excludeApiKey } = options;
	const apiKey = environment.apiKey;

	try {
		const auth: string[][] = [];

		// @TODO delete assetBaseUrl after confirming that all markets use GMC
		if (apiKey && !url.includes(environment.assetBaseUrl) && !excludeApiKey) {
			auth.push(['x-api-key', apiKey]);
		}

		if (credentials) {
			auth.push(['Authorization', 'Basic ' + btoa(`${credentials.username}:${credentials.password}`)]);
		}

		if (auth.length) {
			if (init && init.headers) {
				(init.headers as string[][]).push(...auth);
			} else {
				(init.headers as string[][]) = auth;
			}
		}

		const response = await fetch(url, init);

		const ALLOWED_STATUSES = [204, 404];

		if (!response.ok || ALLOWED_STATUSES.includes(response.status)) {
			if (response.status === 404) {
				// VICTOR returns 404 for no data
				warning('Error might be due to VICTOR missing data, please check VICTOR');
				return;
			}

			if (response.status === 403) {
				warning('Fetched file is missing in AWS');

				return { ...(await response.json()), status: response.status };
			}

			return;
		}

		const JSON = await response.json();

		return { ...JSON, status: response.status } as P;
	} catch (error) {
		errorMessage(`Could not load ${url}.`);
		throw error;
	}
}
